export const EventAudienceTypes = [
  { _id: 'disabled', name: 'Albertans with disabilities' },
  { _id: 'community', name: 'Community agency' },
  { _id: 'employers', name: 'Employers' },
  { _id: 'externalSP', name: 'External Service Provider' },
  { _id: 'educators', name: 'Educators' },
  { _id: 'french', name: 'French Speaking Albertans' },
  { _id: 'genderdiverse', name: 'Gender Diverse' },
  { _id: 'public', name: 'General Public' },
  { _id: 'GOAStaff', name: 'GOA Staff' },
  { _id: 'immigrants', name: 'Immigrants' },
  { _id: 'indigenous', name: 'Indigenous Persons' },
  { _id: 'industry', name: 'Industry Sector' },
  { _id: 'jobseekers', name: 'Job Seekers' },
  { _id: 'lowIncome', name: 'Low Income Albertans' },
  { _id: 'oldies', name: 'Mature Workers' },
  { _id: 'parents', name: 'Parents' },
  { _id: 'students', name: 'Students' },
  { _id: 'women', name: 'Women' },
  { _id: 'youth', name: 'Youth' },
];
